import React from 'react'

import { useAppContext } from 'hooks'

import {
	Container,
	Content,
	LogoContainer,
	LogoLink,
	LogoSVG,
	NavList,
	NavItem,
	NavLink,
	NavLinkButton,
	MobileMenuButton,
	MobileMenuButtonIcon,
} from './styledComponents'

export const Navbar = () => {
	const { userModel } = useAppContext()
	const isEmployee = userModel && userModel.user_type === 'employee'
	const isAdmin = userModel && userModel.user_type === 'admin'

	return (
		<Container>
			<Content>
				<LogoContainer>
					<LogoLink to='/'>
						<LogoSVG />
					</LogoLink>
				</LogoContainer>
				<NavList>
					<NavItem>
						<NavLink to='/' exact>
							Home
						</NavLink>
					</NavItem>
					{!isEmployee && !isAdmin && (
						<NavItem>
							<NavLinkButton to='/signIn' exact>
								Sign In
							</NavLinkButton>
						</NavItem>
					)}
					{isEmployee && (
						<NavItem>
							<NavLinkButton to='/portal/dashboard' exact>
								Portal
							</NavLinkButton>
						</NavItem>
					)}
					{isAdmin && (
						<NavItem>
							<NavLinkButton to='/admin/companies' exact>
								Admin
							</NavLinkButton>
						</NavItem>
					)}
				</NavList>
				<MobileMenuButton>
					<MobileMenuButtonIcon />
				</MobileMenuButton>
			</Content>
		</Container>
	)
}
